<template>
  <div class="userWrap">
    <div class="cardList">
      <ul>
        <li v-for="item in docslist" :key="item.id" @click="showCardInfo(item)" :style="{backgroundImage: `url(${cardLoginBack})`}">
          <div class="ruWrap">
            <div class="list_card_left" v-if="cityLogo != ''"><img :src="cityLogo" class="L imgT"></div>
            <div class="list_card_left" v-else><img src="./../../assets/img/images/imgT.jpg" class="L imgT" /></div>
            <div class="ruTop">
              <h3>{{item.cardname}}</h3>
              <p>{{showcardnum(item.cardnumber)}}</p>
            </div>
          </div>
          <div class="poWrap">
            <div class="L" ><em></em></div>
            <div class="R">查看详情</div>
          </div>
        </li>
      </ul>
      <div class="bottomheight"></div>
    </div>
    <div class="bottom">
      <div class="item1" @click="bindCard" :style="{background: `${colourName}`}">
        <p>绑定新卡</p>
      </div>
      <div class="item2" @click="noValidCard">
        <p>不可用的卡</p>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "@/api";
import { mapMutations } from "vuex";
import JmmToast from '@/components/JmmToast'
import wx from "weixin-js-sdk";
export default {
  name: "userWrap",
  data() {
    return {
      colourName: '#ff1734',
      cardLoginBack: require("../../assets/img/images/bgCard.png"),
      token: "",
      sign: "",
      docslist: "",
      cityLogo: "",   // 城市logo
      channel: '',   // 判断渠道ID
      displayType: "1",
    };
  },
  computed: {
    styleVar() {
      return {
        '--colourName': this.colourName
      }
    }
  },
  created() {
    this.merchantId = this.$route.query.merchantId;
    if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
      localStorage.setItem('cityMerchantId', this.merchantId);
    }
    // 色调选择
    this.displayType = localStorage.getItem("displayType");
    if(this.displayType === '0'){
      this.colourName = "#f8992d";
      this.cardLoginBack = require("../../assets/img/images/new/bgCard.png");
    }
    this.cityLogo = localStorage.getItem("cityLogo");
    this.token = this.$route.query.token;
    this.sign = this.$route.query.sign;
    this.openId = this.$route.query.openId;
    this.channel = this.$route.query.channel;
    //判断渠道ID
    if(null == this.channel || undefined == this.channel){
      this.channel = '';
    }
  },
  components: {},
  mounted() {
    this.getList();
    this.gobackpage();
  },
  methods: {
    // 点击登录
    async getList() {
      let _this = this;
      try {
        let testToken = "lmojakdhkadocfaccfjocklccdfkhgoj";
        let testSign = "dpbijiiiefibmadgopamipinnnpnphof";
        let info={
          sign: _this.sign == undefined ? testSign : _this.sign,
          cardRights: "40000,50000",
          channel: _this.channel,
        };
        localStorage.setItem("reToken",_this.token == undefined ? testToken : _this.token);
        const { code, data, message } = await api.user.cardValid(info);
        if (code == "000000") {
          this.docslist = data;
          console.log(this.docslist.length);
          console.log(this.docslist);
        } else {
          // HyrToast(submsg || msg)
        }
      } catch (err) {
        console.log(err);
      }
    },
    bindCard:function(){
      let _this = this;
      let testToken = _this.token == undefined ? "lmojakdhkadocfaccfjocklccdfkhgoj" : _this.token;
      let testSign = _this.sign == undefined ? "dpbijiiiefibmadgopamipinnnpnphof" : _this.sign;
      var nowTimestmp=new Date().getTime();
      window.location.href = "/cardbind.html#/?merchantId=" + this.merchantId + "&channel=" + this.channel + "&token="+testToken+"&sign="+testSign+"&timestamp="+nowTimestmp;
    },
    noValidCard:function(){
      let _this = this;
      let testToken = _this.token == undefined ? "lmojakdhkadocfaccfjocklccdfkhgoj" : _this.token;
      let testSign = _this.sign == undefined ? "dpbijiiiefibmadgopamipinnnpnphof" : _this.sign;
      var nowTimestmp=new Date().getTime();
      window.location.href = "/cardexpirelist.html#/?token="+testToken+"&sign="+testSign+"&timestamp="+nowTimestmp+"&openId="+_this.openId;
    },
    showCardInfo:function(item){
       let _this = this;
       let testToken = _this.token == undefined ? "lmojakdhkadocfaccfjocklccdfkhgoj" : _this.token;
       let testSign = _this.sign == undefined ? "dpbijiiiefibmadgopamipinnnpnphof" : _this.sign;
       window.location.href = "https://pay.kangou.cn/paycenter/api/card/html/toCardDetails?businessId=10002&card="+item.cardnumber+"&userId="+testSign+"&token="+testToken + "&stylsType=" + this.displayType;
    },
    showcardnum:function(card){
      //if(card.length<12){
      //   return card+" (11位卡仅限公众号使用)";
      //}else{
        return card;
      //}
    },
    gobackpage:function(){
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") { 
        //微信环境
        wx.miniProgram.getEnv(function (res) {
          if (res.miniprogram) {
            //监听返回按钮，回到小程序页面
            window.addEventListener("popstate", function (e) {
              JmmToast("00000000000");
              wx.miniProgram.reLaunch({ url: '/pages/personalCenter/personalCenter' });
            }, false);
          } else {       
            //非小程序环境下逻辑
            //JmmToast("只支持小程序访问");
            return false;
          }
        });
      } else {        
        //非小程序环境下逻辑
        //JmmToast("非小程序环境不能跳转");
        return false;
      }
    }
  },
};
</script>

<style lang="stylus">
@import '../../assets/css/common.styl';
@import '../../assets/css/icon.css';
@import '../../assets/css/stylesheet.css';

.userWrap {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f5f5f5;
}

.cardList {
  width: calc(100% - 40px);
  margin: 20px auto;
}

.cardList li {
  width: 100%;
  height: 265px;
  background: url('../../assets/img/images/bgCard.png') no-repeat center center;
  background-size: cover;
  margin: 20px 0;
  color: #fff;
  border-radius: 15px;
}

.ruWrap {
  width: calc(100% - 40px);
  margin: 0 auto;
}

.ruWrap img {
  width: 100px;
  height: 100px;
}

.poWrap {
  width: calc(100% - 60px);
  margin: 70px auto 0;
  height: auto;
}

.poWrap span {
  border: 1px solid #ff799e;
  background: #ff799e;
  display: inline-block;
  margin-left: 10px;
  padding: 0px 5px;
  border-radius: 5%;
}

.poWrap em {
  font-size: 33px;
}

.L {
  float: left;
}

.R {
  float: right;
  font-size: 28px;
  line-height: 53px;
  height: 33px;
}

.ruTop {
  padding-top: 50px;
}

.ruTop h3 {
  font-size: 34px;
}

.ruTop p {
  font-size: 28px;
}

.imgT {
  margin: 40px 20px 0 20px;
}

i {
  vertical-align: middle;
  font-size: 18px;
}

.bottom {
  position: fixed;
  bottom: 0px;
  background-color: #fff;
  width: 100%;
  height: 80px;
  text-align: center;
}

.item1 {
  width: 50%;
  background: var(--colourName);
  float: left;
}

.item1 p {
  margin: 0;
  font-size: 28px;
  color: #fff;
  line-height: 80px;
}

.item2 {
  width: 50%;
  background: #999999;
  float: left;
}

.item2 p {
  margin: 0;
  font-size: 28px;
  color: #fff;
  line-height: 80px;
}

.bottomheight {
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/view/cardlist/index.vue